import { PAYMENT_ID_STRIPE } from "./constants/payment.js";

export default (cardDoc) => {
  return {
    id: cardDoc.id,
    option: PAYMENT_ID_STRIPE,
    title: `${cardDoc.get("card.brand") || ""} ${cardDoc.get("card.last4") || ""}`,
  };
};
